// Enum usado como um default para nomenclatura de cores

export enum Colors {
    primary = 'primary',
    secondary = 'secondary',
    tertiary = 'tertiary',
    neutral = 'neutral',
    success = 'success',
    warning = 'warning',
    error = 'error',
    info = 'info',
    white = 'white',
    yellow = 'yellow',
    green = 'green',
    light_green = 'light_green',
}
